import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { superUserList } from "../../redux/actions/superUserAction";
import "../products/productDetail.css";
import SuperUserTableData from "./superUserTableData";
import ErrorPopup from "../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../components/utilites/loader";
import NumberPagination from "../../components/Pagination/number-pagination";

const SuperUserTable = ({ search, page_no }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [superUserListData, setSuperUserListData] = useState([]);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    setLoading(true);
    fetchSuperList();
  }, [page, search]);

  const fetchSuperList = () => {
    dispatch(superUserList({ search, page }, onSuccess, onError));
  };
  const onSuccess = (data) => {
    setLoading(false);
    setSuperUserListData(data.data.data);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  return (
    <>
      <div>
        <div className="table-container text-nowrap">
          <table className="main-table">
            <thead>
              <tr className="table-rows">
                <th className="table-heads " width={"4%"}>
                  #
                </th>
                <th className="table-heads " width={"12%"}>
                  Company Employee ID
                </th>
                <th className="table-heads " width={"15%"}>
                  Name
                </th>
                <th className="table-heads " width={"15%"}>
                  Email Address
                </th>
                <th className="table-heads " width={"10%"}>
                  Phone Number
                </th>
                <th className="table-heads " width={"10%"}>
                  Division
                </th>
                <th className="table-heads " width={"22%"}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody style={{ position: "relative" }}>
              {loading === true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : superUserListData?.superUsers?.length > 0 ? (
                <>
                  {superUserListData?.superUsers?.map((eachRow, index) => (
                    <SuperUserTableData
                      key={eachRow.id}
                      data={eachRow}
                      index={index}
                      fetchSuperList={fetchSuperList}
                      currentPage={superUserListData?.pagination?.currentPage}
                    />
                  ))}
                </>
              ) : (
                <tr>
                  <td
                    colSpan="1"
                    className="text-center no-data-container fs_16"
                  >
                    <span>~ No Data Found ~</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className={loading === true ? `loading-event` : ""}>
          {superUserListData?.pagination?.totalPages > 0 && (
            <NumberPagination
              setCurrentPage={setPage}
              pagination={superUserListData?.pagination?.currentPage}
              totalPages={superUserListData?.pagination?.totalPages}
              path={"/super-user/user"}
              filters={`${queryString}`}
            />
          )}
        </div>
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </div>
    </>
  );
};

export default SuperUserTable;
